import { AlertNameDictionaryItem } from '@/models/dictionary/alertName';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { IAlertNameDictionaryApi } from '@/types';

export const useAlertNameDictionary = defineStore('alertNameDictionary', () => {
    const itemsAll = shallowRef<AlertNameDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(itemsAll);

    function setData(data: IAlertNameDictionaryApi[]) {
        itemsAll.value = data.map((item) => new AlertNameDictionaryItem(item));
    }

    const items = computed(() => itemsAll.value);

    /** Only items with is_customer_view for Alerts page filter */
    const itemsForAlertFilter = computed(() => itemsAll.value.filter((i) => i.is_customer_view));

    return {
        items,
        itemsForAlertFilter,
        itemById,
        nameById,
        setData,
    };
});
